import React from 'react';
import { ThemeProvider } from 'styled-components';
import App from '../App';
import '../locales/i18n';
import { theme } from '../styledComponents';

export interface IBCProps{
	test?:boolean;
}

export function BasiqConnect(props: IBCProps) {
	const {test} = props;
return(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<App test={test} />
			</ThemeProvider>
	</React.StrictMode>
		);

}

